export const areasQueryKeys = {
  all: ['areas'] as const,
  lists: () => [...areasQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...areasQueryKeys.lists(), { filters }] as const,
};
